import { PublicResource } from '../../resource-types';
import { RawModel } from '../schema';
import { MetadataValueTypes } from './metadata-field-type';

export const FORMAT_C3_YEAR_DATE = 'c3:year-date';
export const FORMAT_C3_ASSET_ID = 'c3:asset-id';

export interface MetadataField extends PublicResource {
  json_schema: string;
  read_only: boolean;
  required: boolean;
  uses_suggestions: boolean;
  value_type: MetadataValueTypes;
}

export const metadataField: RawModel = {
  type: 'metadata-field',
  plural: 'metadata-fields',
  JSONApi: true,
  useWorker: true,
  attributes: {
    id: 'UUID',
    json_schema: 'string',
    read_only: 'boolean',
    required: 'boolean',
    uses_suggestions: 'boolean',
    value_type: 'string'
  },
  relationships: {}
};
